import React, { useEffect, useState } from "react";
import {
  getCategorys,
  getDepartments,
  getEmployee,
  getProfitCenter,
  InsertAnnounceMents,
} from "../../services/dataService";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import Breadcrumb from "../../components/common/Breadcrumb";

const AnnounceMent = () => {
  const UID = localStorage.getItem("userId");
  const [employees, setEmployees] = useState([]);
  const [departments, setDepartment] = useState([]);
  const [loading, setloading] = useState(false);
  const isAdmin = localStorage.getItem("IsAdmin");

  const departmentIds = localStorage.getItem("DepartmentId") || ""; // Retrieve the value or default to an empty string
  const Dep = departmentIds.split(",")[0] || null; // Split and get the first ID, or set to null if not found
  const [category, setCategory] = useState([]);
  const [profitcenter, setProfitcenter] = useState([]);
  const [filteroptions, setFilteroptions] = useState([]);
  const [selectedFilterType, setSelectedFilterType] = useState("");
  const [selectedFilterValue, setSelectedFilterValue] = useState("");
  const [searchQuery, setSearchQuery] = useState(""); // New state for search query
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [announceMents, setAnnounceMents] = useState({
    Id: "",
    Heading: "",
    Description: "",
    Employees: [],
    Doc: [],
  });

  // Data fetching functions remain the same
  const FetchEmployees = async () => {
    try {
      const response = await getEmployee(UID);

      const details =
        isAdmin == 1
          ? response.data.data
          : response.data.data.filter((el) => el.DepartmentId == Dep);
      setEmployees(details);
      setFilteredEmployees(details);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await getCategorys(UID);
      setCategory(response.data.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchDepartment = async () => {
    try {
      const response = await getDepartments(UID);
      setDepartment(response.data.data);
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };

  const fetchProfitCenters = async () => {
    try {
      const response = await getProfitCenter(UID);
      setProfitcenter(response.data.data);
    } catch (error) {
      console.error("Error fetching profit centers:", error);
    }
  };

  const handleFilterTypeChange = (e) => {
    const filterType = e.target.value;
    setSelectedFilterType(filterType);
    setSelectedFilterValue("");

    const filterOptions =
      filterType === "Department"
        ? departments.map((el) => ({ id: el.Id, name: el.Name }))
        : filterType === "Profitcenter"
        ? profitcenter.map((el) => ({ id: el.Id, name: el.Name }))
        : filterType === "Category"
        ? category.map((el) => ({ id: el.Id, name: el.Name }))
        : [];

    setFilteroptions(filterOptions);
    applyFilters(filterType, "", searchQuery); // Apply filters with search query
  };

  const handleFilterValueChange = (e) => {
    const filterValue = e.target.value;
    setSelectedFilterValue(filterValue);
    applyFilters(selectedFilterType, filterValue, searchQuery);
  };

  // New function to handle search input
  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    applyFilters(selectedFilterType, selectedFilterValue, query);
  };

  // Consolidated filter application function
  const applyFilters = (filterType, filterValue, search) => {
    let filtered = employees;

    // Apply category/department/profit center filter
    if (filterValue) {
      filtered = employees.filter((employee) => {
        switch (filterType) {
          case "Department":
            return employee.DepartmentId === filterValue;
          case "Profitcenter":
            return employee.ProfitCenterId === filterValue;
          case "Category":
            return employee.CategoryId === filterValue;
          default:
            return true;
        }
      });
    }

    // Apply search filter
    if (search) {
      const lowerQuery = search.toLowerCase();
      filtered = filtered.filter(
        (employee) =>
          employee.Name.toLowerCase().includes(lowerQuery) ||
          employee.Code.toLowerCase().includes(lowerQuery)
      );
    }

    setFilteredEmployees(filtered);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedEmployees(filteredEmployees.map((emp) => emp.Id));
    } else {
      setSelectedEmployees([]);
    }
  };

  const handleEmployeeSelect = (employeeId) => {
    setSelectedEmployees((prev) =>
      prev.includes(employeeId)
        ? prev.filter((id) => id !== employeeId)
        : [...prev, employeeId]
    );
  };

  // const handleFileChange = (e) => {
  //     const files = Array.from(e.target.files);
  //     files.forEach(file => {
  //         const reader = new FileReader();
  //         reader.onload = (event) => {
  //             const base64 = event.target.result;
  //             const fileData = {
  //                 id: Date.now() + Math.random(),
  //                 name: file.name,
  //                 size: file.size,
  //                 type: file.type,
  //                 base64: base64,
  //                 isImage: file.type.startsWith('image/')
  //             };

  //             setUploadedFiles(prev => [...prev, fileData]);
  //             setAnnounceMents(prev => ({
  //                 ...prev,
  //                 Doc: [...prev.Doc, fileData.base64]
  //             }));
  //         };
  //         reader.readAsDataURL(file);
  //     });
  // };
  const MAX_SIZE_MB = 50;

  const compressImage = (file, quality = 0.6) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      const img = new Image();

      reader.onload = (e) => {
        img.src = e.target.result;
      };

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        canvas.toBlob(
          (blob) => {
            const reader2 = new FileReader();
            reader2.onloadend = () => resolve(reader2.result);
            reader2.readAsDataURL(blob);
          },
          "image/jpeg",
          quality
        );
      };

      reader.readAsDataURL(file);
    });
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);

    files.forEach(async (file) => {
      const sizeInMB = file.size / (1024 * 1024);
      if (sizeInMB > MAX_SIZE_MB) {
        alert(
          `${file.name} is too large (> ${MAX_SIZE_MB}MB) and cannot be uploaded.`
        );
        return;
      }

      let base64 = "";
      const isImage = file.type.startsWith("image/");

      if (isImage) {
        // Compress image
        base64 = await compressImage(file);
      } else {
        // Read as base64 without compression
        base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject("Failed to read file");
          reader.readAsDataURL(file);
        });
      }

      const fileData = {
        id: Date.now() + Math.random(),
        name: file.name,
        size: file.size,
        type: file.type,
        base64,
        isImage,
      };

      setUploadedFiles((prev) => [...prev, fileData]);
      setAnnounceMents((prev) => ({
        ...prev,
        Doc: [...prev.Doc, fileData.base64],
      }));
    });
  };

  const updateFileState = (file, base64) => {
    const fileData = {
      id: Date.now() + Math.random(),
      name: file.name,
      size: file.size,
      type: file.type,
      base64,
      isImage: file.type.startsWith("image/"),
    };

    setUploadedFiles((prev) => [...prev, fileData]);
    setAnnounceMents((prev) => ({
      ...prev,
      Doc: [...prev.Doc, fileData.base64],
    }));
  };
  const removeFile = (fileId) => {
    const fileIndex = uploadedFiles.findIndex((file) => file.id === fileId);
    setUploadedFiles((prev) => prev.filter((file) => file.id !== fileId));
    setAnnounceMents((prev) => ({
      ...prev,
      Doc: prev.Doc.filter((_, index) => index !== fileIndex),
    }));
  };

  const viewFile = (file) => {
    if (file.isImage) {
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
                    <html>
                        <head>
                            <title>${file.name}</title>
                            <style>
                                body { margin: 0; padding: 20px; background: #f0f0f0; text-align: center; }
                                img { max-width: 100%; height: auto; box-shadow: 0 4px 8px rgba(0,0,0,0.1); }
                                h3 { color: #333; margin-bottom: 20px; }
                            </style>
                        </head>
                        <body>
                            <h3>${file.name}</h3>
                            <img src="${file.base64}" alt="${file.name}" />
                        </body>
                    </html>
                `);
        newWindow.document.close();
      }
    } else if (file.type.includes("pdf")) {
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
                    <html>
                        <head>
                            <title>${file.name}</title>
                            <style>
                                body { margin: 0; padding: 0; }
                                iframe { width: 100%; height: 100vh; border: none; }
                                .error { padding: 20px; text-align: center; color: #666; }
                            </style>
                        </head>
                        <body>
                            <iframe src="${file.base64}" type="application/pdf">
                                <div class="error">
                                    <h3>PDF Preview</h3>
                                    <p>Your browser doesn't support PDF preview.</p>
                                    <p>File: ${file.name}</p>
                                    <a href="${file.base64}" download="${file.name}">Download PDF</a>
                                </div>
                            </iframe>
                        </body>
                    </html>
                `);
        newWindow.document.close();
      }
    } else {
      const link = document.createElement("a");
      link.href = file.base64;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const getFileIcon = (type) => {
    if (type.startsWith("image/")) return "🖼️";
    if (type.includes("pdf")) return "📄";
    if (type.includes("word")) return "📝";
    if (type.includes("excel") || type.includes("spreadsheet")) return "📊";
    if (type.includes("text")) return "📄";
    if (type.includes("powerpoint") || type.includes("presentation"))
      return "📊";
    return "📎";
  };

  const getViewButtonText = (type) => {
    if (type.startsWith("image/")) return "👁️ View";
    if (type.includes("pdf")) return "📄 Preview";
    return "📥 Download";
  };

  const handleShareAnnounceMent = async (e) => {
    e.preventDefault();
    setloading(true);
    const payload = {
      ...announceMents,
      Employees: selectedEmployees,
      UserId: UID,
    };

    console.log("Submitting announcement:", payload);

    try {
      const response = await InsertAnnounceMents(payload);
      console.log("✅ Announcement created:", response);

      if (response.status === 200 || response.status === 201) {
        toast.success("Announcement submitted successfully!");

        setAnnounceMents({
          Id: "",
          Heading: "",
          Description: "",
          Employees: [],
          Doc: [],
        });

        setUploadedFiles([]);
        setSelectedEmployees([]);
        setSelectedFilterType("");
        setSelectedFilterValue("");
        setloading(false);
        setSearchQuery(""); // Reset search query
        setFilteroptions([]);
        setFilteredEmployees(employees);
      }
    } catch (error) {
      setloading(false);

      console.error("❌ Error creating announcement:", error);
      if (error.response) {
        alert(`Server Error: ${error.response.data.message}`);
      } else if (error.request) {
        alert("No response from server. Please check your connection.");
      } else {
        alert("Error: " + error.message);
      }
    }
  };

  const isAllSelected =
    filteredEmployees.length > 0 &&
    selectedEmployees.length === filteredEmployees.length;
  const isIndeterminate =
    selectedEmployees.length > 0 &&
    selectedEmployees.length < filteredEmployees.length;

  useEffect(() => {
    fetchCategory();
    fetchDepartment();
    fetchProfitCenters();
    FetchEmployees();
  }, [UID]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="w-full px-4 py-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <Breadcrumb title="Back" />
          <Link to="/SharedAnnounceMents">
            <button className="btn btn-success">View Announcements</button>
          </Link>
        </div>

        <h1 className="text-4xl font-bold text-gray-900 text-center mb-2">
          Create New Announcement
        </h1>
        <p className="text-gray-600 text-center">
          Share important updates with your team
        </p>

        {/* Main Content */}
        <div className="w-full mx-auto space-y-8">
          {/* Announcement Title - Full Width */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <label className="block text-lg font-semibold text-gray-700 mb-4">
              Announcement Title <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              value={announceMents.Heading}
              onChange={(e) =>
                setAnnounceMents({ ...announceMents, Heading: e.target.value })
              }
              className="w-full px-6 py-4 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
              placeholder="Enter announcement title"
            />
          </div>

          {/* Description - Full Width */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <label className="block text-lg font-semibold text-gray-700 mb-4">
              Description <span className="text-red-500">*</span>
            </label>
            <textarea
              value={announceMents.Description}
              onChange={(e) =>
                setAnnounceMents({
                  ...announceMents,
                  Description: e.target.value,
                })
              }
              className="w-full px-3 py-2 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
              rows="3"
              placeholder="Enter detailed announcement description"
            />
          </div>

          {/* File Upload Section */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <label className="block text-lg font-semibold text-gray-700 mb-4">
              Attachments (Optional)
            </label>
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center hover:border-indigo-400 transition-colors">
              <div className="mb-4">
                <input
                  multiple
                  type="file"
                  onChange={handleFileChange}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-3 file:px-6 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 transition-all"
                />
              </div>
            </div>

            {uploadedFiles.length > 0 && (
              <div className="mt-6">
                <h3 className="text-lg font-semibold text-gray-700 mb-4">
                  Uploaded Files
                </h3>
                <div className="overflow-x-auto">
                  <table className="w-full border border-gray-200 rounded-lg overflow-hidden">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Preview
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          File Name
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Size
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Type
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {uploadedFiles.map((file) => (
                        <tr key={file.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-lg">
                              {file.isImage ? (
                                <img
                                  src={file.base64}
                                  alt={file.name}
                                  className="w-10 h-10 object-cover rounded"
                                />
                              ) : (
                                <span className="text-2xl">
                                  {getFileIcon(file.type)}
                                </span>
                              )}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm font-medium text-gray-900">
                              {file.name}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="text-sm text-gray-500">
                              {formatFileSize(file.size)}
                            </div>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-blue-100 text-blue-800">
                              {file.type.split("/")[1]?.toUpperCase() || "FILE"}
                            </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex space-x-2">
                              <button
                                onClick={() => viewFile(file)}
                                className="text-indigo-600 hover:text-indigo-900 font-medium text-sm"
                              >
                                {getViewButtonText(file.type)}
                              </button>
                              <button
                                onClick={() => removeFile(file.id)}
                                className="text-red-600 hover:text-red-900 font-medium text-sm"
                              >
                                🗑️ Remove
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>

          {/* Employee Selection */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-6">
              Select Recipients
            </h2>

            {/* Filter Controls */}
            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Filter By
                </label>
                <select
                  value={selectedFilterType}
                  onChange={handleFilterTypeChange}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                >
                  <option value="">Select filter type</option>
                  <option value="Category">Category</option>
                  {isAdmin == 1 && (
                    <option value="Department">Department</option>
                  )}
                  <option value="Profitcenter">Profit Center</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Filter Value
                </label>
                <select
                  value={selectedFilterValue}
                  onChange={handleFilterValueChange}
                  disabled={!selectedFilterType}
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-50 disabled:cursor-not-allowed transition-all"
                >
                  <option value="">All employees</option>
                  {filteroptions.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Search Employees
                </label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Search by name or code"
                  className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all"
                />
              </div>
              <div className="flex items-end">
                <label className="flex items-center space-x-2 bg-gray-50 px-4 py-3 rounded-lg">
                  <input
                    type="checkbox"
                    checked={isAllSelected}
                    ref={(checkbox) => {
                      if (checkbox) checkbox.indeterminate = isIndeterminate;
                    }}
                    onChange={handleSelectAll}
                    className="h-[15px] w-[15px] text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                  />
                  <span className="text-sm font-medium text-gray-700">
                    Select All ({filteredEmployees.length})
                  </span>
                </label>
              </div>
              <div className="flex items-end">
                <div className="bg-indigo-50 px-4 py-3 rounded-lg">
                  <p className="text-sm text-indigo-700 font-medium">
                    {selectedEmployees.length} employee
                    {selectedEmployees.length !== 1 ? "s" : ""} selected
                  </p>
                </div>
              </div>
            </div>

            {/* Employee List */}
            <div className="bg-gray-50 rounded-lg p-4 max-h-96 overflow-y-auto">
              {filteredEmployees.length === 0 ? (
                <p className="text-center text-gray-500 py-8">
                  No employees found
                </p>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                  {filteredEmployees.map((employee) => (
                    <div
  key={employee.Id}
  className={`flex items-center p-4 rounded-lg border cursor-pointer transition-all ${
    selectedEmployees.includes(employee.Id)
      ? "bg-indigo-50 border-indigo-300 shadow-md"
      : "bg-white border-gray-200 hover:bg-gray-50 hover:shadow-sm"
  }`}
  onClick={() => handleEmployeeSelect(employee.Id)}
>
  <input
    type="checkbox"
    checked={selectedEmployees.includes(employee.Id)}
    onClick={(e) => e.stopPropagation()} // ✅ prevent parent click
    onChange={() => handleEmployeeSelect(employee.Id)} // only handle toggle once
    className="h-[15px] w-[15px] text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded mr-3"
  />
  <div className="flex-1">
    <p className="text-sm font-medium text-gray-900">
      {employee.Name}
    </p>
    <p className="text-xs text-gray-500">
      Code: {employee.Code}
    </p>
  </div>
</div>

                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-center space-x-6 pb-8">
            <button className="px-8 py-4 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-all">
              Cancel
            </button>
            <button
              onClick={handleShareAnnounceMent}
              disabled={
                !announceMents.Heading ||
                !announceMents.Description ||
                selectedEmployees.length === 0 ||
                loading
              }
              className={`px-8 py-4 font-medium rounded-lg transition-all shadow-lg
    ${
      loading
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-indigo-600 hover:bg-indigo-700 text-white"
    }`}
            >
              {loading ? "Sharing..." : "Share Announcement"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnounceMent;
